import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const Layout = () => {
  const { pathname } = useLocation();
  const variant = pathname === "/" ? "dark" : "light";

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.backgroundColor = variant === "light" ? "#ffffff" : "#0A0A0A";
  }, [pathname, variant]);

  return (
    <>
      <Navbar variant={variant} />
      <main className={pathname === "/" ? "bg-ink-900" : "bg-white"}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};
